// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.modal-mask[data-v-fc218c70] {
  position: fixed;
  z-index: 9998;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.modal-wrapper[data-v-fc218c70] {
  display: grid;
  place-content: center;
  height: 100vh;
  overflow-y: scroll;
}
.modal-container[data-v-fc218c70] {
  width: clamp(300px, 95vw, 140ch);
  padding: 1rem;
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
}
.modal-header[data-v-fc218c70] {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #000;
  padding: 0 0 9px 0;
}
.modal-body[data-v-fc218c70] {
  margin: 0.5rem 0;
  padding: 0;
  max-height: 80vh;
}
.modal-footer[data-v-fc218c70] {
  display: flex;
  justify-content: flex-end;
}
.modal-default-button[data-v-fc218c70] {
  display: block;
  margin-top: 1rem;
}
.modal-enter-active[data-v-fc218c70],
.modal-leave-active[data-v-fc218c70] {
  transition: opacity 0.2s;
}
.modal-enter-from[data-v-fc218c70],
.modal-leave-to[data-v-fc218c70] {
  opacity: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/assignmentPrototype/JsonViewer.vue"],"names":[],"mappings":";AAwBA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,oCAAoC;AACtC;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,aAAa;EACb,kBAAkB;AACpB;AAEA;EACE,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;AAC3C;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;AAEA;;EAEE,wBAAwB;AAC1B;AAEA;;EAEE,UAAU;AACZ","sourcesContent":["<script setup>\ndefineEmits(['close']);\n</script>\n\n<template>\n  <div class=\"modal-mask\">\n    <div class=\"modal-wrapper\">\n      <div class=\"modal-container\">\n        <div class=\"modal-header\">\n          <slot name=\"header\"> default header </slot>\n          <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Fermer\" @click=\"$emit('close')\">\n            <span aria-hidden=\"true\">&times;</span>\n          </button>\n        </div>\n\n        <div class=\"modal-body\">\n          <slot name=\"body\"> default body </slot>\n        </div>\n      </div>\n    </div>\n  </div>\n</template>\n\n<style scoped>\n.modal-mask {\n  position: fixed;\n  z-index: 9998;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n.modal-wrapper {\n  display: grid;\n  place-content: center;\n  height: 100vh;\n  overflow-y: scroll;\n}\n\n.modal-container {\n  width: clamp(300px, 95vw, 140ch);\n  padding: 1rem;\n  background-color: #fff;\n  border-radius: 3px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: #000;\n  padding: 0 0 9px 0;\n}\n\n.modal-body {\n  margin: 0.5rem 0;\n  padding: 0;\n  max-height: 80vh;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.modal-default-button {\n  display: block;\n  margin-top: 1rem;\n}\n\n.modal-enter-active,\n.modal-leave-active {\n  transition: opacity 0.2s;\n}\n\n.modal-enter-from,\n.modal-leave-to {\n  opacity: 0;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
